import type { Role } from '@medicail/shared';
import { readStorage, removeStorage, writeStorage } from '@/lib/storage';

const KEY = 'medicail.dev.auth';

export interface DevIdentity {
  email: string;
  role: Role;
}

export function getDevIdentity(): DevIdentity | null {
  const raw = readStorage(KEY);
  if (!raw) return null;
  try {
    const v = JSON.parse(raw) as Partial<DevIdentity>;
    if (typeof v.email === 'string' && v.email && (v.role === 'user' || v.role === 'admin')) {
      return { email: v.email, role: v.role };
    }
  } catch {
    /* corrupt value */
  }
  return null;
}

export function devSignIn(identity: DevIdentity): void {
  writeStorage(KEY, JSON.stringify(identity));
}

export function devSignOut(): void {
  removeStorage(KEY);
}

export async function devToken(): Promise<string | null> {
  const id = getDevIdentity();
  return id ? `dev:${id.email}:${id.role}` : null;
}
